import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { MapPin, Phone, Mail, Clock, Sparkles } from 'lucide-react';
export function Contacto() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success('Mensaje enviado. Nos pondremos en contacto pronto.');
      (e.target as HTMLFormElement).reset();
    }, 1500);
  };
  return <div className="py-12 md:py-20" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-239">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-serif text-cafe-primary mb-6" data-id="element-240">
            Contacto
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg text-cafe-text/80" data-id="element-241">
            ¿Tienes alguna duda o sugerencia? Escríbenos y estaremos encantados
            de atenderte.
          </motion.p>
        </div>

        {/* Welcome editorial block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        duration: 0.6
      }} className="max-w-5xl mx-auto mb-16 md:mb-20 bg-cafe-card rounded-3xl overflow-hidden shadow-soft border border-cafe-border/50" data-id="element-242">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center" data-id="element-243">
            <div className="aspect-[4/5] md:aspect-square overflow-hidden" data-id="element-244">
              <img src="https://cdn.magicpatterns.com/uploads/x4dpYXKejkRbBEmjeG4m4s/Captura_de_pantalla_2026-05-27_a_las_12.38.19.png" alt="Equipo de Trastienda Café frente al local bajo el cartel iluminado" className="w-full h-full object-cover" data-id="element-245" />
            </div>
            <div className="p-8 md:p-12 lg:p-14 text-center md:text-left" data-id="element-246">
              <Sparkles size={24} className="text-cafe-accent mb-4 mx-auto md:mx-0" data-id="element-247" />
              <h2 className="text-2xl md:text-3xl font-serif text-cafe-primary mb-4 leading-tight" data-id="element-248">
                Aquí estamos para <span className="italic" data-id="element-249">recibirte</span>
              </h2>
              <p className="text-cafe-text/80 leading-relaxed" data-id="element-250">
                Trastienda Café es, sobre todo, las personas que te atienden.
                Ven a vernos, escríbenos o llámanos — estaremos encantadas de
                atenderte.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 max-w-5xl mx-auto" data-id="element-251">
          {/* Contact Info Placeholders */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="space-y-8" data-id="element-252">
            <h2 className="text-2xl font-serif text-cafe-primary mb-6" data-id="element-253">
              Información
            </h2>
            <div className="space-y-6" data-id="element-254">
              <div className="flex items-start" data-id="element-255">
                <div className="w-12 h-12 bg-cafe-card rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-256">
                  <MapPin className="text-cafe-accent" size={24} data-id="element-257" />
                </div>
                <div data-id="element-258">
                  <h3 className="font-medium text-cafe-primary text-lg mb-2" data-id="element-259">
                    Dirección
                  </h3>
                  <div className="space-y-3 mt-2" data-id="element-260">
                    <div data-id="element-261">
                      <p className="font-medium text-cafe-primary text-xs uppercase tracking-wider mb-1" data-id="element-262">
                        Local 1
                      </p>
                      <p className="text-cafe-text/80 text-sm" data-id="element-263">
                        C/ San Miguel 17
                      </p>
                      <p className="text-cafe-text/60 text-sm" data-id="element-264">
                        San Pedro de Alcántara, Marbella
                      </p>
                    </div>
                    <div data-id="element-265">
                      <p className="font-medium text-cafe-primary text-xs uppercase tracking-wider mb-1" data-id="element-266">
                        Local 2
                      </p>
                      <p className="text-cafe-text/80 text-sm" data-id="element-267">C.C. Petunias</p>
                      <p className="text-cafe-text/80 text-sm" data-id="element-268">
                        C/ Pintor José Caballero
                      </p>
                      <p className="text-cafe-text/60 text-sm" data-id="element-269">
                        San Pedro de Alcántara, Marbella
                      </p>
                    </div>
                    <div data-id="element-270">
                      <p className="font-medium text-cafe-primary text-xs uppercase tracking-wider mb-1" data-id="element-271">
                        Local 3
                      </p>
                      <p className="text-cafe-text/80 text-sm" data-id="element-272">
                        C/ Juan Illesca Pavón 2
                      </p>
                      <p className="text-cafe-text/60 text-sm" data-id="element-273">
                        San Pedro de Alcántara, Marbella
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-start" data-id="element-274">
                <div className="w-12 h-12 bg-cafe-card rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-275">
                  <Phone className="text-cafe-accent" size={24} data-id="element-276" />
                </div>
                <div data-id="element-277">
                  <h3 className="font-medium text-cafe-primary text-lg" data-id="element-278">
                    Teléfono
                  </h3>
                  <span className="inline-block mt-2 text-xs italic text-cafe-text/50 bg-cafe-bg px-3 py-1 rounded-full border border-cafe-border" data-id="element-279">
                    Pronto disponible
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-280">
                <div className="w-12 h-12 bg-cafe-card rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-281">
                  <Mail className="text-cafe-accent" size={24} data-id="element-282" />
                </div>
                <div data-id="element-283">
                  <h3 className="font-medium text-cafe-primary text-lg" data-id="element-284">
                    Email
                  </h3>
                  <a href="mailto:greta@trastiendacafe.com" className="inline-block mt-2 text-cafe-accent hover:text-cafe-primary transition-colors font-medium break-all" data-id="element-285">
                    greta@trastiendacafe.com
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-286">
                <div className="w-12 h-12 bg-cafe-card rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-287">
                  <Clock className="text-cafe-accent" size={24} data-id="element-288" />
                </div>
                <div data-id="element-289">
                  <h3 className="font-medium text-cafe-primary text-lg mb-2" data-id="element-290">
                    Horario
                  </h3>
                  <div className="space-y-3 mt-2" data-id="element-291">
                    <div data-id="element-292">
                      <p className="font-medium text-cafe-primary text-xs uppercase tracking-wider mb-1" data-id="element-293">
                        Lunes a Viernes
                      </p>
                      <p className="text-cafe-text/80 text-sm" data-id="element-294">
                        7:00 – 15:00 · 17:00 – 21:00
                      </p>
                    </div>
                    <div data-id="element-295">
                      <p className="font-medium text-cafe-primary text-xs uppercase tracking-wider mb-1" data-id="element-296">
                        Sábado y Domingo
                      </p>
                      <p className="text-cafe-text/80 text-sm" data-id="element-297">
                        8:00 – 14:00 · 16:00 – 20:30
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-298">
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl shadow-soft border border-cafe-border/50" data-id="element-299">
              <h2 className="text-2xl font-serif text-cafe-primary mb-6" data-id="element-300">
                Envíanos un mensaje
              </h2>
              <div className="space-y-4" data-id="element-301">
                <div data-id="element-302">
                  <label htmlFor="nombre" className="block text-sm font-medium text-cafe-text mb-1" data-id="element-303">
                    Nombre
                  </label>
                  <input type="text" id="nombre" required className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent outline-none transition-colors" data-id="element-304" />
                </div>
                <div data-id="element-305">
                  <label htmlFor="email" className="block text-sm font-medium text-cafe-text mb-1" data-id="element-306">
                    Email
                  </label>
                  <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent outline-none transition-colors" data-id="element-307" />
                </div>
                <div data-id="element-308">
                  <label htmlFor="mensaje" className="block text-sm font-medium text-cafe-text mb-1" data-id="element-309">
                    Mensaje
                  </label>
                  <textarea id="mensaje" required rows={4} className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent outline-none transition-colors resize-none" data-id="element-310" />
                </div>
                <button type="submit" disabled={isSubmitting} className="w-full bg-cafe-primary text-white py-3 rounded-xl font-medium hover:bg-cafe-accent transition-colors disabled:opacity-70 flex justify-center items-center mt-2" data-id="element-311">
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      </div>
    </div>;
}